<template>
  <span style="display: content;">
    <template v-if="route.routeName && !route.children">
      <router-link :to="
        route.routeName ? {
          name: route.routeName,
          params: route.routeParams
        } : ''" class="nav-link">
        <b-icon :icon="route.icon"></b-icon>
        {{route.label}}
      </router-link>
    </template>
    <template v-else>
      <b-nav-item-dropdown>
        <template v-slot:button-content>
          <b-icon :icon="route.icon"></b-icon>
          {{route.label}}
        </template>
        <li v-for="(child, index) in route.children" :key="'ddItem' + index" class="custom-dd">
          <router-link :to="
            child.routeName ? {
              name: child.routeName,
              params: child.routeParams
            } : ''" class="nav-link">
            <b-icon :icon="child.icon"></b-icon>
            {{child.label}}
          </router-link>
        </li>
      </b-nav-item-dropdown>
    </template>
  </span>
</template>

<script>
export default {
  props: {
    route: Object
  }
}
</script>

<style lang="scss" scoped>
  .custom-dd {
    font-size: .875rem;
  }
</style>
